module.exports = __webpack_public_path__ + "img/restauration_systeme_C.G_010.ac6c5f74.jpg";